import config from '../config';
import Helper from "../helpers";

const apiBaseUrl = config.apiBaseUrl;

export const getUsersForVenue = async (venueKey: string) => {
    try {
        const response = await fetch(`${apiBaseUrl}/api/venue/${venueKey}/users`);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching users for venue:', error);
        throw error;
    }
}

export const getUserNextSession = async (userId: string) => {
    const token = await Helper.getCookie('wh-jwt');
    try {
        const response = await fetch(`${apiBaseUrl}/api/Sessions/user/next/${userId}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            credentials: 'include'
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching user next session:', error);
        throw error;
    }
}

export const getVenueUserProfile = async (venueKey: string) => {
    const token = await Helper.getCookie('wh-jwt');
    try {
        const response = await fetch(`${apiBaseUrl}/api/users/${venueKey}/uesr`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            credentials: 'include'
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching venue user profile:', error);
        throw error;
    }
}

export const getUserUpcomingSessionCount = async (userId: string) => {
    const token = await Helper.getCookie('wh-jwt');
    try {
        const response = await fetch(`${apiBaseUrl}/api/Sessions/user/count/${userId}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            credentials: 'include'
        });
        if (!response.ok) {
            let error = new Error('Network response was not ok');
            console.error('Error fetching user upcoming session count:', error);
            return 0;
        }
        const data = await response.json();
        return data.sessionCount ?? 0;
    } catch (error) {
        console.error('Error fetching user next session:', error);
        throw error;
    }
}

export const fetchVenueUsers = async (venueKey: string) => {
    const token = await Helper.getCookie('wh-jwt');
    try {
        const response = await fetch(`${apiBaseUrl}/api/users/venueusers/${venueKey}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            credentials: 'include'
        });
        if (!response.ok) {
            console.error('Failed to fetch users', response.statusText);
            throw new Error('Network response was not ok');
        }

        const data = await response.json();
        return data;
        
    } catch (error) {
        console.error('Error fetching users for venue:', error);
        throw error;
    }
};

// Admin "Reset sign up": emails a member who never finished a fresh link back to the start of their
// invitation. Leave subscriptionId empty to reuse the invitation they originally followed.
export const resetUserSignup = async (venueKey: string, userGuid: string, subscriptionId: number | null = null) => {
    const token = await Helper.getCookie('wh-jwt');
    const response = await fetch(`${apiBaseUrl}/api/SubscriptionOffer/reset-signup/${venueKey}/${userGuid}`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({ subscriptionId })
    });

    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
        throw new Error(data.message || data.Message || 'Could not reset the sign up.');
    }

    return data as { status: string; message: string; inviteUrl?: string; planName?: string };
};

export const bookUserSession = async (userId: string, sessionId: string, deductUserToken: boolean = true) => {
    const token = await Helper.getCookie('wh-jwt');
    try {
        const response = await fetch(`${apiBaseUrl}/api/Sessions/book/${sessionId}?userid=${userId}&deuctuser=${deductUserToken}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            credentials: 'include'
        });

        if (!response.ok) {
            alert('Failed to book session');
            return false
        } 
        let data = await response.json();
        if (data) {
            alert('Session booked successfully');
            return true;
        } else {
            alert('Failed to book session');
            return false;
        }
    } catch (error) {
        console.error('Error booking session:', error);
        alert('Failed to book session');
        return false;
    }
}

export const getUserVenueTokens = async (venueKey: string) => {
    const token = await Helper.getCookie('wh-jwt');
    try {
        const response = await fetch(`${apiBaseUrl}/api/users/token/${venueKey}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            credentials: 'include'
        });

        if (!response.ok) {
            return {Tokens: 0, Error: 'Failed to fetch user venue tokens'};
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching user venue tokens:', error);
        throw error;
    }
}

export const changeUserTokens = async (venueKey:string, userId: string, tokens: number) => {
    
    const formData = {
      tokenQty: tokens,
      userId: userId,
      venueKey :venueKey,
    };
    const authToken = await Helper.getCookie('wh-jwt');
    fetch(`${apiBaseUrl}/api/users/token`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(formData),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error('Failed to add token');
        }
      });
  };

// Get current user information
export const getCurrentUser = async () => {
    try {
        const token = await Helper.getCookie('wh-jwt');
        const userId = await Helper.getCookie('wh.user.id');
        
        if (!userId) {
            throw new Error('No user ID found');
        }

        const response = await fetch(`${apiBaseUrl}/api/users/user/${userId}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            credentials: 'include'
        });

        if (!response.ok) {
            throw new Error('Failed to fetch user information');
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching current user:', error);
        throw error;
    }
};

// Update current user information
export const updateCurrentUser = async (userData: any) => {
    try {
        const token = await Helper.getCookie('wh-jwt');
        const userId = await Helper.getCookie('wh.user.id');
        
        if (!userId) {
            throw new Error('No user ID found');
        }

        const response = await fetch(`${apiBaseUrl}/api/users/user/${userId}`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(userData)
        });

        if (!response.ok) {
            throw new Error('Failed to update user information');
        }

        return await response.json();
    } catch (error) {
        console.error('Error updating current user:', error);
        throw error;
    }
};

// Bulk update tokens for multiple users
export const bulkChangeUserTokens = async (venueKey: string, userIds: string[], tokenQty: number) => {
    const token = await Helper.getCookie('wh-jwt');
    const response = await fetch(`${apiBaseUrl}/api/users/tokens/bulk`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({ venueKey, userIds, tokenQty })
    });
    if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.message || 'Failed to bulk update tokens');
    }
    return response.json();
};

// Soft delete user from venue
export const softDeleteUserFromVenue = async (venueKey: string, userId: string) => {
    try {
        const token = await Helper.getCookie('wh-jwt');
        
        const response = await fetch(`${apiBaseUrl}/api/users/venueuser/delete/${venueKey}/${userId}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            credentials: 'include'
        });

        if (!response.ok) {
            // Try to parse error message from JSON response
            try {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to remove user from venue');
            } catch (jsonError) {
                // If JSON parsing fails, throw a generic error
                throw new Error('Failed to remove user from venue');
            }
        }

        return await response.json();
    } catch (error) {
        console.error('Error removing user from venue:', error);
        throw error;
    }
};